import React from 'react'
import { FlexView, Card } from '../../../components/common'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'


const Detail = styled.p`
    padding: 0;
    margin: 0 5px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: ${props => props.gray ? '#777777' : 'inherit'};
    flex-wrap: wrap;
`

const Details = styled(FlexView)`
    border-right: 1px solid #E0E0E0;
    padding-right: 35px;
    flex-wrap: wrap;

    &:last-child {
        border-right: none
    }
`

const CardWrap = styled(Card)`
    flex-wrap: wrap;
`
const FlexWrap = styled(FlexView)`
    flex-wrap: wrap;
`

const JobSummarySubheader = ({jobDetailsData }) => {
     const { t } = useTranslation()
    return (
        <CardWrap margin="20px 0" minWidth="70%">
            <FlexWrap height="100%" width="100%" alignItems="center" flexDirection='row' justifyContent="space-between" fontSize="medium" flexWrap="wrap">
                {jobDetailsData && jobDetailsData.map((detail, i) => (
                    <Details alignItems="center" flexDirection='column' justifyContent="center" fontSize="medium" key={i}>
                        <Detail gray="true">{t(detail.title)}</Detail>
                        <Detail>{detail.value}</Detail>
                    </Details>
                ))}
                {/* <FlexView flexDirection="column" alignItems="center">
                    <Icon name='edit' width="15px" height="15px" margin="0px" color="black"/>
                </FlexView> */}
            </FlexWrap>
           
        </CardWrap>)
}

export default JobSummarySubheader